// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';

const requiredPart = t.interface({
  tag: t.literal('BETWEEN_DATES'),
  field: t.string,
  from: DateSchema,
  to: DateSchema,
});

export const BetweenDatesFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface BetweenDatesFilter extends t.TypeOf<typeof BetweenDatesFilterSchema> {}
